export default {
  to: "To: ",

  attachment: {
    label: "Attachments: ",
    pdf: "{{number}}.pdf",
  },

  subject: {
    label: "Subject: ",
    value: "Invoice: {{number}} | {{clientName}}",
  },

  message: {
    label: "Message: ",
  },

  sendMeCopy: "Send me a copy",

  button: {
    send: "Send",
    cancel: "Cancel",
  },
}
